var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.500000, 0.500000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.707,0 L1,0 C0.4485,0 0,0.449 0,1 L0,10 C0,10.5515 0.4485,11 1,11 L8,11 C8.5515,11 9,10.5515 9,10 L9,2.293 L6.707,0 Z M5,6.5 L5,9 L4,9 L4,6.5 L2.5,6.5 L4.5,4.5 L6.5,6.5 L5,6.5 Z M6,3 L6,0.5 L8.5,3 L6,3 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.f4205492f7740f48de21c4157cb7275e.svg";
export { ForwardRef as ReactComponent };